import { render } from "./NameModal.vue?vue&type=template&id=32df3e64&scoped=true&ts=true"
import script from "./NameModal.vue?vue&type=script&lang=ts"
export * from "./NameModal.vue?vue&type=script&lang=ts"

import "./NameModal.vue?vue&type=style&index=0&id=32df3e64&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32df3e64"]])

export default __exports__